// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/list_vision_members.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionMemberView } from "./vision_membership_pb";
import { file_vision_membership_v1_vision_membership } from "./vision_membership_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/list_vision_members.proto.
 */
export const file_vision_membership_v1_list_vision_members: GenFile = /*@__PURE__*/
  fileDesc("Ci52aXNpb24vbWVtYmVyc2hpcC92MS9saXN0X3Zpc2lvbl9tZW1iZXJzLnByb3RvEhtwcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEihgEKGExpc3RWaXNpb25NZW1iZXJzUmVxdWVzdBJMCgZwYXJhbXMYASABKAsyPC5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuTGlzdFZpc2lvbk1lbWJlcnNSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSK0AQoZTGlzdFZpc2lvbk1lbWJlcnNSZXNwb25zZRJNCgZyZXN1bHQYASABKAsyPS5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuTGlzdFZpc2lvbk1lbWJlcnNSZXNwb25zZS5SZXN1bHQaSAoGUmVzdWx0Ej4KB21lbWJlcnMYASADKAsyLS5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuVmlzaW9uTWVtYmVyVmlld2IGcHJvdG8z", [file_vision_membership_v1_vision_membership]);

/**
 * @generated from message protos.vision.membership.v1.ListVisionMembersRequest
 */
export type ListVisionMembersRequest = Message<"protos.vision.membership.v1.ListVisionMembersRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.ListVisionMembersRequest.Params params = 1;
   */
  params?: ListVisionMembersRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.ListVisionMembersRequest.
 * Use `create(ListVisionMembersRequestSchema)` to create a new message.
 */
export const ListVisionMembersRequestSchema: GenMessage<ListVisionMembersRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_list_vision_members, 0);

/**
 * @generated from message protos.vision.membership.v1.ListVisionMembersRequest.Params
 */
export type ListVisionMembersRequest_Params = Message<"protos.vision.membership.v1.ListVisionMembersRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.membership.v1.ListVisionMembersRequest.Params.
 * Use `create(ListVisionMembersRequest_ParamsSchema)` to create a new message.
 */
export const ListVisionMembersRequest_ParamsSchema: GenMessage<ListVisionMembersRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_list_vision_members, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.ListVisionMembersResponse
 */
export type ListVisionMembersResponse = Message<"protos.vision.membership.v1.ListVisionMembersResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.ListVisionMembersResponse.Result result = 1;
   */
  result?: ListVisionMembersResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.ListVisionMembersResponse.
 * Use `create(ListVisionMembersResponseSchema)` to create a new message.
 */
export const ListVisionMembersResponseSchema: GenMessage<ListVisionMembersResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_list_vision_members, 1);

/**
 * @generated from message protos.vision.membership.v1.ListVisionMembersResponse.Result
 */
export type ListVisionMembersResponse_Result = Message<"protos.vision.membership.v1.ListVisionMembersResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.membership.v1.VisionMemberView members = 1;
   */
  members: VisionMemberView[];
};

/**
 * Describes the message protos.vision.membership.v1.ListVisionMembersResponse.Result.
 * Use `create(ListVisionMembersResponse_ResultSchema)` to create a new message.
 */
export const ListVisionMembersResponse_ResultSchema: GenMessage<ListVisionMembersResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_list_vision_members, 1, 0);

